import { some } from 'lodash';

import { AppSessionData } from 'src/constants/dataTypes/sessionDataTypes';

export type EmailToUserIdMap = Record<string, string>;

/**
 * Builds a unique email → Cognito userId map from portal session cookies,
 * including workspace_login when its email is not already present.
 */
export const getEmailsFromPortalSessions = (
  portalIdToSession: Record<string, AppSessionData>,
): EmailToUserIdMap => {
  const { workspace_login, ...portalSessions } = portalIdToSession;
  const appSessions: AppSessionData[] = Object.values(portalSessions);

  if (
    workspace_login?.email &&
    !some(appSessions, (session) => session.email === workspace_login.email)
  ) {
    appSessions.push(workspace_login);
  }

  return appSessions.reduce((emailToUserId, session) => {
    const { email, userId } = session;
    if (email && userId) {
      emailToUserId[email] = userId;
    }
    return emailToUserId;
  }, {} as EmailToUserIdMap);
};
